import React, { createContext, useContext, useState, useCallback } from 'react';
import { University, universities } from '../types/universities';

interface UniversityContextType {
  selectedUniversity: University;
  setSelectedUniversity: (university: University) => void;
}

const UniversityContext = createContext<UniversityContextType | undefined>(undefined);

export function UniversityProvider({ children }: { children: React.ReactNode }) {
  const [selectedUniversity, setSelectedUniversityState] = useState<University>(() => {
    const savedUniversity = localStorage.getItem('selectedUniversity');
    try {
      if (savedUniversity) {
        const found = universities.find(u => u.id === savedUniversity);
        if (found) return found;
      }
    } catch (e) {
      console.error('Error loading university preference:', e);
    }
    return universities[0];
  });

  const setSelectedUniversity = useCallback((university: University) => {
    setSelectedUniversityState(university);
    localStorage.setItem('selectedUniversity', university.id);
  }, []);

  return (
    <UniversityContext.Provider value={{ 
      selectedUniversity, 
      setSelectedUniversity
    }}>
      {children}
    </UniversityContext.Provider>
  );
}

export function useUniversity() {
  const context = useContext(UniversityContext);
  if (context === undefined) {
    throw new Error('useUniversity must be used within a UniversityProvider');
  }
  return context;
}